import React, { useEffect, useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import './appshell.css';

const AppShell = ({ headerProps, footerProps, sidebar, children, hero, player, activePath }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const isHomePage = activePath === '/';

  const handleToggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
  };

  useEffect(() => {
    setIsSidebarOpen(false);
  }, [activePath]);

  return (
    <div className={`app-shell ${isSidebarOpen ? 'app-shell--sidebar-open' : ''}`}>
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <Header {...headerProps} onToggleSidebar={sidebar ? handleToggleSidebar : undefined} />
      {hero ? <div className="app-shell__hero">{hero}</div> : null}
      <div className={`app-shell__body ${isHomePage ? 'app-shell__body--home' : 'app-shell__body--route'}`}>
        {sidebar ? (
          <aside className="app-shell__sidebar" aria-label="Secondary navigation">
            <div className="app-shell__sidebar-inner">
              {sidebar}
              <button className="app-shell__sidebar-close" type="button" onClick={handleCloseSidebar}>
                Close
              </button>
            </div>
          </aside>
        ) : null}
        <main id="main-content" className="app-shell__main" tabIndex="-1" onClick={handleCloseSidebar}>
          <div className={isHomePage ? 'home-frame' : 'route-frame'}>{children}</div>
        </main>
      </div>
      {player ? <div className="app-shell__player" aria-label="Global player controls">{player}</div> : null}
      <Footer {...footerProps} />
    </div>
  );
};

export default AppShell;
